
import AppConfig from './app_config.json';
import Amplify , {Auth, graphqlOperation } from 'aws-amplify';
import awsconfig from './aws-exports';
import dateFormat  from 'dateformat';
import { v4 as uuidv4 } from 'uuid';
import isMobilejs from 'ismobilejs';
import axios from 'axios';
import jszip from 'jszip';
import router from './router'
var iconv = require('iconv-lite');

Amplify.configure(awsconfig);

// モバイル判定用のライブラリを初期化
var isMobile = isMobilejs(window.navigator);

// 接続設定--開始
Amplify.configure({
    'aws_appsync_graphqlEndpoint': AppConfig.appsync_graphql_endpoint,
    'aws_appsync_region': AppConfig.auth.region,
    'aws_appsync_authenticationType': 'AMAZON_COGNITO_USER_POOLS',
    Auth: {
        region: AppConfig.auth.region,
        userPoolId: AppConfig.auth.userPoolId,
        userPoolWebClientId: AppConfig.auth.userPoolWebClientId,
    }
});
// 接続設定--終了

// 日本語化設定
const dict = {
    // 完全一致翻訳(Cognito等)
    msg : {
      'User is disabled.' : '「データ共有サービス」の有効なライセンスが\r\n存在しません。',
      'Invalid code provided, please request a code again.' : '確認キーが有効期限切れです。\r\n確認キーを再発行してください。',
      'Invalid verification code provided, please try again.' : '正しい確認キーを入力してください。',
      'Invalid code received for user' : '正しいワンタイムパスワードを入力してください。',
      'Already found an entry for the provided username.' : '既に同じユーザーIDが使用されています。ユーザーIDを変更してください。',
      'PreSignUp failed with error Already found an entry for the provided username.' : '既に同じユーザーIDが使用されています。ユーザーIDを変更してください。',
      'PreSignUp failed with error WeplatAuthTmpRec not found.' : '既に初回登録が完了しています。トップページからログイン後にユーザーを追加してください。',
      // TODO 追加で翻訳したいエラーがあれば追加
    },
    // 正規表現一致翻訳(Cognito等)
    reg_msg : {
      ".*validation error.* detected: Value .* at 'userCode' failed to satisfy constraint:.*" : '正しいワンタイムパスワードを入力してください。',
      // TODO 追加で翻訳したいエラーがあれば追加
    },
    // 例外(Cognito等)
    exception : {
      'NotAuthorizedException' : '正しいユーザーID、パスワードを入力してください。',
      'UsernameExistsException' : '既に同じユーザーIDが使用されています。ユーザーIDを変更してください。',
      'InvalidPasswordException' : 'パスワードは10文字以上 かつ 数字、英大文字、英小文字を混在したパスワードを設定してください。',
      'EnableSoftwareTokenMFAException' : '正しいワンタイムパスワードを入力してください。',
      'InvalidParameterException' : '正しい値を入力してください。',
      'UserLambdaValidationException' : '正しい値を入力してください。',
      'LimitExceededException' : '試行制限を超えました。しばらくしてからもう一度お試しください。',
      'ExpiredCodeException' : '確認キーが有効期限切れです。\r\n確認キーを再発行してください。',
      // TODO 追加で翻訳したいエラーがあれば追加
    },
    // エラーコード(AppSync)
    error_code : {
      'WDERROR_FOLD_DEL_USER_EXISTS' : '顧問先ユーザーが存在するため完全削除できません。ユーザー管理の顧問先ユーザーを確認してください。',
      'WDERROR_LOGIN_USER_NOT_FOUND' : '管理者によりユーザーIDが削除されました。ログアウトします。',
      'WDERROR_LOGIN_TOKEN_EXPIRED' : '自動ログインの有効期限切れです。再度ログインして下さい。',
      // TODO 追加でコードから文字列を返却したいエラーがあれば追加
    },
  };

// Amplify,cognito,appSyncから返却されるエラーを日本語に翻訳
Amplify.GetJaErrMsg = function(err){
  var logoutflg = false;
  var mess = null;

  // App Syncから発生したエラーか判定
  if(err.errors && err.errors.length > 0){
    // App Syncのエラーコードから文言を作成
    mess = dict.error_code[err.errors[0].message];
    // 強制ログアウトさせるべきエラーコードかチェック
    if(err.errors[0].message === 'WDERROR_LOGIN_USER_NOT_FOUND' || 
      err.errors[0].message === 'WDERROR_LOGIN_TOKEN_EXPIRED'){
      logoutflg = true;
    }
  }

  if(!mess){
    // メッセージ優先で日本語化
    mess = dict.msg[err.message];
  }

  if(!mess){
    // 正規表現に一致するかチェック
    for (let [key, value] of Object.entries(dict.reg_msg)) {
      var regExp = RegExp(key, 'g');
      if(regExp.test(String(err.message))){
        mess = value;
        break;
      }
    }
  }

  if(!mess){
    // 例外から日本語化
    mess = dict.exception[err.code];
  }
  if(!mess){
      // デバック用メッセージ
      if(AppConfig.debug && (err.code || err.message)){
          alert(err.code);
          alert(err.message);
      }
      // 想定外のエラー共通メッセージ
      return Constant.Msg.Unexpected;
  }

  // 強制ログアウト
  if(logoutflg){
    setTimeout(() => {
      router.push({ path: "/" }, () => {}, () => {});
    }, 2000);

    Amplify.Auth.signOut();
  }

  return mess;
}

// GraphQLの自動リトライ機能を含むラッパー処理
// ネットワークエラーなら1度だけリトライ
// トークンの有効期限切れなら強制ログイン対象のエラーが発生
var GraphqlUtil = {};
GraphqlUtil.exec = async function (query, val){

  // セッションの有効期限をチェック
  let _result;
  await Amplify.Auth.currentUserPoolUser().then(user => {
    _result = user;
  }).catch(error => {
    Logger.log(error);
    _result = null;
  });

  // 有効期限切れ
  if(!_result){
    // セキュリティトークンの期限切れエラーを発生させる。
    var err = new Error();
    err.errors = [{message : 'WDERROR_LOGIN_TOKEN_EXPIRED'}]; 
    throw err;
  }

  Logger.log(query);

  let errorException = null;
  let result = await Amplify.API.graphql(graphqlOperation(query, val)).catch(error => {
      // エラーメッセージ取得
      errorException = error;
  });

  Logger.log(result);

  // リトライ
  if(errorException){
    errorException = null;
    result = await Amplify.API.graphql(graphqlOperation(query, val)).catch(error => {
      // エラーメッセージ取得
      errorException = error;
    });
  }

  // サーバ例外を返却
  if(errorException){
    throw errorException;
  }

  return result;
}

// GraphQLのクエリ定義--開始
var Queries = {};

// 自ユーザー取得
Queries.GetUser = /* GraphQL */ `
  query GetUser {
    GetUser {
        user_id
        user_name
        disp_name
        email
        auth_type
        mfa_type
        company_id
        company_disp_name
        preferred_user_name
    }
  }
`;

// 自社情報取得
Queries.GetCompany = /* GraphQL */ `
  query GetCompany {
    GetCompany {
        uuid
        name
        lisence_lmt
        strage_lmt
        disp_name
        intr_company_id
        intr_company_disp_name
        intr_company_lisence_lmt
        intr_company_strage_lmt
        created_dt
        created_user
        update_dt
        update_user
    }
  }
`;

// 自ユーザーの参照可能なフォルダ一覧取得
Queries.GetFolds = /* GraphQL */ `
  query GetFolds {
    GetFolds {
      folds {
        uuid
        app_id
        company_id
        created_dt
        created_user
        disp_num_l1
        disp_num_l2
        disp_num_l3
        disp_size_l1
        disp_size_l2
        disp_size_l3
        fold_id_l1
        fold_id_l2
        fold_id_l3
        intr_company_id
        name_l1
        name_l2
        name_l3
        trash_l1
        trash_l2
        trash_l3
        req_trash_flg
        auth_flg
        update_dt
        update_user
      }
    }
  }
`;

// アップロードURL取得
Queries.GetUploadSignedUrl = /* GraphQL */ `
  query GetUploadSignedUrl($key: ID!, $fold_id: String, $msg_id: String ) {
    GetUploadSignedUrl(key: $key, fold_id: $fold_id, msg_id: $msg_id) {
        url
        expires
        date_dt
    }
  }
`;

// ダウンロードロードURL取得
Queries.GetDownloadSignedUrl = /* GraphQL */ `
  query GetDownloadSignedUrl($key: ID!) {
    GetDownloadSignedUrl(key: $key) {
        url
        expires
        date_dt
        name
        file_type_cl
    }
  }
`;

// フォルダIDから依頼一覧取得(検索機能あり)
Queries.GetRequests = /* GraphQL */ `
  query GetRequests($fold_id: String!, $status: String, $self_flg: String, $deliv_date_from: String, $deliv_date_to: String, $search_text: String) {
    GetRequests(fold_id: $fold_id, status: $status, self_flg: $self_flg, deliv_date_from: $deliv_date_from, deliv_date_to: $deliv_date_to, search_text: $search_text) {
        uuid
        req_date
        req_user_id
        req_user_name
        status
        deliv_date
        title
        trash
        created_dt
        update_dt
        created_user
        update_user
    }
  }
`;

// 依頼IDから依頼明細一覧取得
Queries.GetRequestDtls = /* GraphQL */ `
  query GetRequestDtls($req_id: String!) {
    GetRequestDtls(req_id: $req_id) {
        uuid
        req_id
        msg
        send_user_id
        send_user_name
        send_company_name
        file_cnt
        created_dt
        update_dt
        created_user
        update_user
    }
  }
`;

// 依頼明細IDからファイル一覧取得
Queries.GetFiles = /* GraphQL */ `
  query GetFiles($req_dtl_id: String!) {
    GetFiles(req_dtl_id: $req_dtl_id) {
      uuid
      req_dtl_id
      disp_num
      name
      size
      disp_size
      file_type_cl
      file_type_id
      intr_company_id
      company_id
      virus_check_state
      created_dt
      update_dt
      created_user
      update_user
    }
  }
`;

// 管理者用 ユーザ一覧取得
Queries.GetUsers = /* GraphQL */ `
  query GetUsers {
    GetUsers {
      part_users {
        user_id
        user_name
        disp_name
        email
        auth_type
        mfa_type
        company_id
        company_disp_name
        preferred_user_name
      }
      own_users {
        user_id
        user_name
        disp_name
        email
        auth_type
        mfa_type
        company_id
        company_disp_name
        preferred_user_name
      }
    }
  }
`;

// 管理者用 権限取得
Queries.GetAuths = /* GraphQL */ `
  query GetAuths($user_id: String, $fold_id: String) {
    GetAuths(user_id: $user_id, fold_id: $fold_id) {
        user_id
        fold_id
    }
  }
`;

// 未読一覧取得
Queries.GetUnreads = /* GraphQL */ `
  query GetUnreads {
    GetUnreads {
        uuid
        user_id
        resource_id
        resource_type
        created_dt
        created_user
        update_dt
        update_user
    }
  }
`;

var Mutations = {};

// 新規依頼作成
Mutations.CreateRequest = /* GraphQL */ `
  mutation CreateRequest(
    $input: CreateRequestInput!
  ) {
    CreateRequest(input: $input) {
      uuid
      fold_id
      req_date
      req_user_id
      req_user_name
      status
      deliv_date
      title
      trash
      first_msg
      first_dtl_id
      created_dt
      update_dt
      created_user
      update_user
    }
  }
`;

// 新規依頼明細作成
Mutations.CreateRequestDtl = /* GraphQL */ `
  mutation CreateRequestDtl(
    $input: CreateRequestDtlInput!
  ) {
    CreateRequestDtl(input: $input) {
      uuid
      req_id
      msg
      send_company_name
      send_user_id
      send_user_name
      file_cnt
      created_dt
      update_dt
      created_user
      update_user
    }
  }
`;

// 新規ファイル作成
Mutations.CreateFile = /* GraphQL */ `
  mutation CreateFile(
    $input: CreateFileInput!
  ) {
    CreateFile(input: $input) {
      uuid
      req_dtl_id
      disp_num
      name
      size
      disp_size
      file_type_cl
      file_type_id
      intr_company_id
      company_id
      virus_check_state
      created_dt
      update_dt
      created_user
      update_user
    }
  }
`;

// フォルダ一括更新
Mutations.UpdateFolds = /* GraphQL */ `
  mutation UpdateFolds(
    $input: UpdateFoldsInput!
  ) {
    UpdateFolds(input: $input) {
      folds{
        uuid
        app_id
        company_id
        created_dt
        created_user
        disp_num_l1
        disp_num_l2
        disp_num_l3
        disp_size_l1
        disp_size_l2
        disp_size_l3
        fold_id_l1
        fold_id_l2
        fold_id_l3
        intr_company_id
        name_l1
        name_l2
        name_l3
        trash_l1
        trash_l2
        trash_l3
        req_trash_flg
        auth_flg
        update_dt
        update_user
      }
    }
  }
`;

// フォルダ一括更新
Mutations.UpdateUserFoldDispNum = /* GraphQL */ `
  mutation UpdateUserFoldDispNum(
    $input: UpdateUserFoldDispNumInput!
  ) {
    UpdateUserFoldDispNum(input: $input) {
      folds{
        uuid
        app_id
        company_id
        created_dt
        created_user
        disp_num_l1
        disp_num_l2
        disp_num_l3
        disp_size_l1
        disp_size_l2
        disp_size_l3
        fold_id_l1
        fold_id_l2
        fold_id_l3
        intr_company_id
        name_l1
        name_l2
        name_l3
        trash_l1
        trash_l2
        trash_l3
        req_trash_flg
        auth_flg
        update_dt
        update_user
      }
    }
  }
`;

// 新規ユーザー追加
Mutations.AddUser = /* GraphQL */ `
  mutation AddUser(
    $input: AddUserInput!
  ) {
    AddUser(input: $input) {
        user_id
        user_name
        disp_name
        email
        auth_type
        mfa_type
        company_id
        company_disp_name
        preferred_user_name
    }
  }
`;

// ユーザー登録完了
Mutations.AddUserComplete = /* GraphQL */ `
  mutation AddUserComplete {
    AddUserComplete {
        user_id
        user_name
        disp_name
        email
        auth_type
        mfa_type
        company_id
        company_disp_name
        preferred_user_name
    }
  }
`;

// パスワード変更完了
Mutations.UpdateUserPasswordComplete = /* GraphQL */ `
  mutation UpdateUserPasswordComplete {
    UpdateUserPasswordComplete {
        user_id
        user_name
        disp_name
        email
        auth_type
        mfa_type
        company_id
        company_disp_name
        preferred_user_name
    }
  }
`;

// Email変更
Mutations.UpdateUserEmail = /* GraphQL */ `
  mutation UpdateUserEmail($email: String!) {
    UpdateUserEmail(email: $email) {
        user_id
        user_name
        disp_name
        email
        auth_type
        mfa_type
        company_id
        company_disp_name
        preferred_user_name
    }
  }
`;

// 担当者名変更
Mutations.UpdateUserDisp = /* GraphQL */ `
  mutation UpdateUserDisp($user_disp: String!) {
    UpdateUserDisp(user_disp: $user_disp) {
        user_id
        user_name
        disp_name
        email
        auth_type
        mfa_type
        company_id
        company_disp_name
        preferred_user_name
    }
  }
`;

// cognito優先ユーザー名変更
Mutations.UpdatePreferredUserName = /* GraphQL */ `
  mutation UpdatePreferredUserName($preferred_user_name: String!) {
    UpdatePreferredUserName(preferred_user_name: $preferred_user_name) {
        user_id
        user_name
        disp_name
        email
        auth_type
        mfa_type
        company_id
        company_disp_name
        preferred_user_name
    }
  }
`;

// フォルダ権限更新
Mutations.UpdateFoldAuths = /* GraphQL */ `
  mutation UpdateFoldAuths(
    $input: UpdateFoldAuthsInput!
  ) {
    UpdateFoldAuths(input: $input) {
      fold_id
      auths {
        user_id
        fold_id
      }
    }
  }
`;

// ユーザー権限更新
Mutations.UpdateUserAuths = /* GraphQL */ `
  mutation UpdateUserAuths(
    $input: UpdateUserAuthsInput!
  ) {
    UpdateUserAuths(input: $input) {
      user_id
      auths {
        user_id
        fold_id
      }
    }
  }
`;

// 未読削除
Mutations.DeleteUnread = /* GraphQL */ `
  mutation DeleteUnread($req_id: String!) {
    DeleteUnread(req_id: $req_id) {
      delete_cnt
    }
  }
`;

// 依頼明細削除
Mutations.DeleteRequestDtl = /* GraphQL */ `
  mutation DeleteRequestDtl($req_dtl_id: String!) {
    DeleteRequestDtl(req_dtl_id: $req_dtl_id) {
      delete_cnt
    }
  }
`;

// 依頼削除
Mutations.DeleteRequest = /* GraphQL */ `
  mutation DeleteRequest($req_id: String!) {
    DeleteRequest(req_id: $req_id) {
      delete_cnt
    }
  }
`;

// フォルダ削除
Mutations.DeleteFold = /* GraphQL */ `
  mutation DeleteFold($fold_id: String!) {
    DeleteFold(fold_id: $fold_id) {
      delete_cnt
    }
  }
`;

// ユーザ削除
Mutations.DeleteUser = /* GraphQL */ `
  mutation DeleteUser($user_id: String!) {
    DeleteUser(user_id: $user_id) {
      delete_cnt
    }
  }
`;

// 依頼更新
Mutations.UpdateRequest = /* GraphQL */ `
  mutation UpdateRequest(
    $input: UpdateRequestInput!
  ) {
    UpdateRequest(input: $input) {
      uuid
      fold_id
      req_date
      req_user_id
      req_user_name
      status
      deliv_date
      title
      trash
      first_msg
      first_dtl_id
      created_dt
      update_dt
      created_user
      update_user
    }
  }
`;

// 依頼ゴミ箱フラグ更新
Mutations.UpdateRequestTrash = /* GraphQL */ `
  mutation UpdateRequestTrash(
    $input: UpdateRequestTrashInput!
  ) {
    UpdateRequestTrash(input: $input) {
      uuid
      fold_id
      req_date
      req_user_id
      req_user_name
      status
      deliv_date
      title
      trash
      first_msg
      first_dtl_id
      created_dt
      update_dt
      created_user
      update_user
    }
  }
`;

// ユーザー更新
Mutations.UpdateUser = /* GraphQL */ `
  mutation UpdateUser(
    $input: UpdateUserInput!
  ) {
    UpdateUser(input: $input) {
      user_id
      user_name
      disp_name
      email
      auth_type
      mfa_type
      company_id
      company_disp_name
      preferred_user_name
    }
  }
`;

// フォルダゴミ箱フラグ更新
Mutations.UpdateFoldTrash = /* GraphQL */ `
  mutation UpdateFoldTrash(
    $input: UpdateFoldTrashInput!
  ) {
    UpdateFoldTrash(input: $input) {
      folds{
        uuid
        app_id
        company_id
        created_dt
        created_user
        disp_num_l1
        disp_num_l2
        disp_num_l3
        disp_size_l1
        disp_size_l2
        disp_size_l3
        fold_id_l1
        fold_id_l2
        fold_id_l3
        intr_company_id
        name_l1
        name_l2
        name_l3
        trash_l1
        trash_l2
        trash_l3
        req_trash_flg
        auth_flg
        update_dt
        update_user
      }
    }
  }
`;

// フォルダ移動
Mutations.MoveRequest = /* GraphQL */ `
  mutation MoveRequest($input: MoveRequestInput!) {
    MoveRequest(input: $input) {
      fold_id
    }
  }
`;

// 使用容量取得
Queries.GetUsedStrage = /* GraphQL */ `
  query GetUsedStrage {
    GetUsedStrage {
      used_strage
      company_name
      fold_id
    }
  }
`;

// GraphQLのクエリ定義--終了

// サーバに渡す際のデータ変換等
//safariだとYYYY-MM-DDフォーマットが「Invalid Date」のためreplace処置
var Convert = {};
// 2020-03-12 00:00:00 のような形式に変換
Convert.dateToStr = function(orgDate){
    return dateFormat(Convert.dateReplace(orgDate), 'yyyy-mm-dd 00:00:00');
}

// 2020-03-12 16:15:05 のような形式に変換
Convert.datetimeToStr = function(orgDate){
    return dateFormat(Convert.dateReplace(orgDate), 'yyyy-mm-dd HH:MM:ss');
}

// 2020-03-12_16:15:05 のような形式に変換 zip向け
Convert.datetimeToZipStr = function(orgDate){
  return dateFormat(Convert.dateReplace(orgDate), 'yyyy-mm-dd_HH:MM:ss');
}

// 2020-03-12 のような画面表示形式に変換
Convert.dateToDispStr = function(orgDate){
  return dateFormat(Convert.dateReplace(orgDate), 'yyyy-mm-dd');
}

// 日付フォーマットはsafari用の処理なので例外を握りつぶして処理継続できるようにする
Convert.dateReplace = function(orgDate){
  try {
    return orgDate.replace(/-/g, "/");
  } catch {
    return orgDate;
  }
}

// Uuid関連クラス
var Uuid = {};
// Uuid生成 重複処理を防ぐため、クライアントで生成
Uuid.getUuid = function(){
    return uuidv4();
}

// その他共通部品
var Util = {};
// 文字列比較
Util.strCmp = function(strA , strB){
  // 文字列比較
  var lenA = strA.length;
  var lenB = strB.length;
  var minlen = lenA > lenB ? lenB : lenA;
  for(var i = 0; i < minlen; i++){
    if(!(strA.charCodeAt(i) === strB.charCodeAt(i))){
      return (strA.charCodeAt(i) - strB.charCodeAt(i));
    }
  }
  // 文字数で判断
  return (lenA - lenB);
}

// 日付フォーマット正規表現
const dateRegex = new RegExp("^[2-9][0-9]{3}-([0][1-9]|[1][0-2])-([0][1-9]|[1-2][0-9]|[3][0-1])$", "g");

// 日付フォーマットチェック
Util.isDateStr = function(str){
  try{
    // 無効な文字列は無視
    if(!str){
      return true;
    }

    // 正規表現チェック
    if(!str.match(dateRegex)){
      return false;
    }

    // 日付変換で想定外のエラーが発生しない
    Convert.dateToStr(str);
    return true;
  } catch {
    return false;
  }
}

var FileUtil = {};
// ファイルUtilの内部関数 ファイルのバイト取得
function readFileAsync(file) {
return new Promise((resolve, reject) => {
        let reader = new FileReader();

        reader.onload = () => {
            resolve(reader.result);
        };

        reader.onerror = reject;

        reader.readAsArrayBuffer(file);
    })
}
FileUtil.upload = async function (url, file){
    const filebyte = await readFileAsync(file);
    const options = {
        headers: {
          'Content-Type': file.type,
        },
      };
    const res = await axios.put(url, filebyte, options);
    return res.data;
}

// ダウンロード コアロジック
FileUtil.downloadCore = async function downloadCore(fileInfo){
  const options = {
    'responseType': 'arraybuffer',
  };
  return await axios.get(fileInfo.url, options);
}
async function downloadCore(fileInfo){
  const options = {
    'responseType': 'arraybuffer',
  };
  return await axios.get(fileInfo.url, options);
}

// ブラウザ用のダウンロード処理
async function downloadForBrowse(fileInfo, byte){
  var blob = new Blob([byte], {type: fileInfo.file_type_cl});
  if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    window.navigator.msSaveOrOpenBlob(blob, fileInfo.name);
  } else {
    var url = window.URL.createObjectURL(blob);
    var a = document.createElement('a');
    document.body.appendChild(a);
    a.href = url;
    a.download = fileInfo.name;
    a.click();
    window.URL.revokeObjectURL(url);
    document.body.removeChild(a);
  }
}

// ファイルダウンロード(単体)
FileUtil.download = async function (fileInfo){
    // ダウンロード
    const res = await downloadCore(fileInfo);
    // ブラウザ用にダウンロードを画面に表示
    downloadForBrowse(fileInfo, res.data);
    return true;
}

// ファイルダウンロード(Zip)
// TODO 一旦、仮実装でクライアント側でZip作成するやり方
FileUtil.downloadZip = async function (fileIdList, downloadAllSizeByte, drowFunc){
  // zip名生成
  var zipFileInfo = {
    file_type_cl : 'application/x-zip-compressed',
    name : Convert.datetimeToZipStr(new Date()) + '.zip',
  };
  let zipByte = null;
  let zipObj = new jszip();
  let downloadedFileSize = 0;
  for (var i = 0; i < fileIdList.length; i++) {
    let fileInfo;
    await GraphqlUtil.exec(Queries.GetDownloadSignedUrl, { 
      key: fileIdList[i]
    }).then(result => {
      fileInfo = result.data.GetDownloadSignedUrl;
    }).catch(error => {
      // エラー処理 
      Logger.log(error);
      throw error;
    });

    // バイナリをダウンロード
    const res = await downloadCore(fileInfo);
    // ヘッダからバイト数を取得してダウンロードパーセントを計算
    downloadedFileSize += parseInt(res.headers['content-length']);
    const parsent = Math.round(downloadedFileSize / downloadAllSizeByte * 100);
    // ダウンロードしたパーセントを描画関数に返却
    drowFunc(parsent);

    // バイナリをzip化
    zipObj.file(fileInfo.name, res.data);
  }
  
  // zipバイナリ取得
  await zipObj.generateAsync({
    type:"blob",
    // Sjisのファイル名に変換
    encodeFileName: fileName => {
      // モバイル判定
      if(!isMobile.any){
        // モバイル以外はWindowsしかサポートしないのでファイル名をWindows向けSJisに変換
        return iconv.encode(fileName, "Windows-31j")
      } else {
        return fileName;
      }
    }
  }).then(function(content) {
      zipByte = content;
  });
  
  // ブラウザ用にダウンロードを画面に表示
  downloadForBrowse(zipFileInfo, zipByte);
  return true;
}

// ファイルタイプからWeplatフォルダの画像ビューワで表示できるか判断
FileUtil.isDispImageFiletype = function(fileType){
  try{
    // MIMEタイプから画像判定
    if('image/jpeg' === fileType){
      return true;
    } else if('image/gif' === fileType){
      return true;
    } else if('image/png' === fileType){
      return true;
    } else if('image/bmp' === fileType){
      return true;
    }
    return false;
  } catch {
    return false;
  }
}

// システム独自の定数クラス
const Constant = {
  // ユーザー権限 
  UserAuthType : {
    // 一般ユーザー
    General : 0,
    // 管理者ユーザー
    Admin : 1,
  },
  UserAuthTypeDisp : {
    // 一般ユーザー
    General : '一般',
    // 管理者ユーザー
    Admin : '管理者',
  },
  // ユーザー種別 
  UserType : {
    // ライセンスのある会社に所属するユーザー
    Host : 1,
    // ライセンスのない会社に所属するユーザー
    Guest : 2,
  },
  // ユーザー ワンタイムパスワード認証設定
  UserMfa : {
    // ワンタイムパスワード認証を使用しない
    Off : '0',
    // ワンタイムパスワード認証を使用する
    On : '1',
    // ワンタイムパスワード認証を設定中
    Setting : '2',
  },
  UserMfaDisp : {
    // ワンタイムパスワード認証を使用しない
    Off : '無効',
    // ワンタイムパスワード認証を使用する
    On : '有効',
    // ワンタイムパスワード認証を設定中
    Setting : '無効（有効化中）',
  },
  //ウィルスチェックステータス
  VirusCheckState : {
    //チェック中orチェック待ち
    Yet : '0',
    //OK
    Ok : '1',
    // ファイルアップロード中
    Uploading : '7',
    //Exception
    Exception : '8',
    //NG
    Ng : '9'
  },
  // 未読通知リソースタイプ
  UnreadResourceType : {
    // 依頼ID
    RequestId : 0,
    // フォルダID
    FoldId : 1,
    // 親フォルダID
    PFoldId : 2,
    // 依頼明細ID
    RequestDtlId : 3,
  },
  // 依頼ステータス 表示
  RequestStatusDisp : {
    // 未完了
    Incomplete : '未完了',
    // 完了
    Complete : '完了',
  },
  // 依頼ステータス
  RequestStatus : {
    // 未完了
    Incomplete : '0',
    // 完了
    Complete : '1',
  },
  // メッセージ
  Msg : {
    // 想定外のエラーメッセージ
    Unexpected : 'システムエラーが発生しました。しばらく経ってからお試しください。',
  },
  MenuItem : {
    UserAdmin : { 
      menuId : 1, 
      title : "ユーザー管理"
    },
    UserLisecse : {
       menuId : 2, 
       title : "利用状況確認" 
    },
    UserAccount : { 
      menuId : 3, 
      title : "アカウント管理" 
    },
    Tutorial : { 
      menuId : 4, 
      title : "ナビ表示" 
    },
    LogOut : { 
      menuId : 99, 
      title : "ログアウト" 
    },
  },
};

// ログ出力関数
var Logger = {};
Logger.log = function(logObj){
  if(AppConfig.env === 'develop'){
    // 開発用ログ
    // TODO amplifyにアップロードする時はコメントアウト
    // console.log(logObj);
    // TODO amplifyにアップロードする時はコメントアウト
  }

  // TODO コンパイルエラーを出さないように追加しているだけで、デバックという環境はありません。
  if(AppConfig.env === 'debug'){
    // 開発用ログ
    // TODO amplifyにアップロードする時はコメントアウト
    alert(logObj);
    // TODO amplifyにアップロードする時はコメントアウト
  }

}

// RestApiUtil
var RestApiUtil = {};
// メール送信キー認証
RestApiUtil.PostMailTokenAuth = async function (key){
  const options = {
      headers: {
        'Content-Type': 'application/json',
      },
    };
  const body = {
    key : key
  }
  var url = AppConfig.rest_api_endpoint + '/api/web/mail_token/auth';
  const res = await axios.post(url, body, options);
  // エラーステータスチェック
  if(res.status !== 200){
    Logger.log(res);
    throw new Error(res.data);
  }
  
  // 通信が正常でもエラーメッセージありなら例外
  if(res.data.errorMessage){
    Logger.log(res.data.errorMessage);
    throw new Error(res.data.errorMessage);
  }
  return JSON.parse(res.data.body);
}

// 管理者ログイン向けWeplat認証、トークン取得
RestApiUtil.PostWeplatToken = async function (username, password){
  const options = {
      headers: {
        'Content-Type': 'application/json',
      },
    };
  const body = {
    username : username,
    password : password,
  }
  var url = AppConfig.rest_api_endpoint + '/api/web/weplat/token';
  const res = await axios.post(url, body, options);
  
  // エラーステータスチェック
  if(res.status !== 200){
    Logger.log(res);
    throw new Error(res.data);
  }
  
  // 通信が正常でもエラーメッセージありなら例外
  if(res.data.errorMessage){
    Logger.log(res.data.errorMessage);
    throw new Error(res.data.errorMessage);
  }
  return JSON.parse(res.data);
}

// パスワードリセット
RestApiUtil.PostPasswordReset = async function (user_id, mail_address){
  const options = {
      headers: {
        'Content-Type': 'application/json',
      },
    };
  const body = {
    user_id : user_id,
    mail_address : mail_address,
  }
  var url = AppConfig.rest_api_endpoint + '/api/web/password/reset';
  const res = await axios.post(url, body, options);

  // エラーステータスチェック
  if(res.status !== 200){
    Logger.log(res);
    throw new Error(res.data);
  }
  
  // 通信が正常でもエラーメッセージありなら例外
  if(res.data.errorMessage){
    Logger.log(res.data.errorMessage);
    throw new Error(res.data.errorMessage);
  }
  return JSON.parse(res.data.body);
}

export default Amplify;

Amplify.Auth = Auth;

export {
    Auth,
    Queries,
    Mutations,
    GraphqlUtil,
    Convert,
    Uuid,
    Util,
    FileUtil,
    isMobile,
    Constant,
    Logger,
    RestApiUtil,
};
